<template>
  <v-layout id="bucket-field" row :class="{'wrap': $vuetify.breakpoint.xsOnly}">
    <v-layout :class="{'wrap': $vuetify.breakpoint.xsOnly}">
      <v-flex
        xs12
        sm6
        :class="{'pr-0': $vuetify.breakpoint.xsAndDown, 'pr-2': $vuetify.breakpoint.smAndUp}">
        <v-autocomplete
          :items="schemaFieldSets"
          append-icon="keyboard_arrow_down"
          box
          dense
          label="Fieldset"
          v-on:change="changedFieldset"
          v-model="field.fieldset">
        </v-autocomplete>
      </v-flex>
      <v-flex
        xs12
        sm6
        :class="{'pl-0': $vuetify.breakpoint.xsAndDown, 'pl-2': $vuetify.breakpoint.smAndUp}">
        <v-autocomplete
          :disabled="field.fieldset == ''"
          :items="fieldNames"
          append-icon="keyboard_arrow_down"
          box
          dense
          label="Field"
          v-model="field.fieldName"
          v-on:change="changedFieldName">
        </v-autocomplete>
      </v-flex>
    </v-layout>

    <v-btn
      v-if="!this.hideSort"
      class="ml-3 mr-0 sort-button"
      style="margin-top:12px !important"
      flat
      icon
      @click.native.stop.exact="resetSortOrder()"
      @click.native.shift="addSortField()">
      <v-flex v-if="sortDirection === 'asc'">
        <v-icon v-html="'arrow_upward'"></v-icon>
        <v-flex v-if="sortPosition > 0" class="sort-order-number">
          {{ sortPosition }}
        </v-flex>
      </v-flex>
      <v-flex v-else>
        <v-icon v-html="'arrow_downward'"></v-icon>
        <v-flex v-if="sortPosition > 0" class="sort-order-number">
          {{ sortPosition }}
        </v-flex>
      </v-flex>
    </v-btn>

    <v-btn
      v-if="!this.hideDelete"
      style="margin-top:11px !important"
      class="mt-0 hidden-xs-only"
      id="createField-delete-btn"
      @click="deleteField()"
      icon>
      <v-icon color="error">cancel</v-icon>
    </v-btn>
    <v-btn
      style="margin-top:-4px !important"
      class="mt-0 ml-0 mb-3 hidden-sm-and-up text-link-button"
      id="createField-delete-btn"
      @click="deleteField()"
      color="error"
      flat>
      <v-icon class="mr-2" color="error">cancel</v-icon>Remove above field
    </v-btn>
  </v-layout>
</template>

<script>

export default {
  name: "bucket-field",
  props: {
    field: {
      type: Object,
      required: true
    },
    schema: {
      type: Object,
      required: true
    },
    sortDirection: {
      type: String,
      default: "desc"
    },
    sortPosition: {
      type: Number,
      default: 0
    },
    hideSort: {
      type: Boolean,
      default: false
    },
    hideDelete: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    schemaFieldSets() {
      return this.schema.fieldsets.map(fieldSet => fieldSet.name)
    },
    fieldNames() {
      let fieldNames = []
      if (this.schema) {
        if ((this.field.fieldset !== "") && (Array.isArray(this.schema.fieldsets))) {
          this.schema.fieldsets.forEach(fieldSet => {
            if (this.field.fieldset === fieldSet.name) {
              const names = fieldSet.fields.map(field => field.name)
              fieldNames = fieldNames.concat(names)
            }
          })
        }
      }
      return fieldNames
    }
  },
  methods: {
    changedFieldName() {
      this.$emit("changed-field", this.field)
    },
    changedFieldset() {
      this.$emit("changed-fieldset", this.field.fieldset)
    },
    resetSortOrder() {
      this.$store.dispatch('resetSortOrder', this.field)
    },
    addSortField() {
      this.$store.dispatch('addSortField', this.field)
    },
    async deleteField() {
      await this.$store.dispatch('deleteDisplayField', this.field)
      await this.$store.dispatch('reindexSortPositions', this.field)
    }
  }
}
</script>

<style>
.sort-order-number {
  position:absolute;
  top:-10px;
  right:0;
}
</style>
